import React from "react";
import IconButton from "@mui/material/IconButton";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Popper from "@mui/material/Popper";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";

const MenuPopup = (props) => {
	const [openProfile, setOpenProfile] = React.useState(false);
	const anchorRef = React.useRef(null);

	const handleToggle = () => {
		setOpenProfile((prevOpen) => !prevOpen);
	};

	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}

		setOpenProfile(false);
	};

	function handleListKeyDown(event) {
		if (event.key === "Tab") {
			event.preventDefault();
			setOpenProfile(false);
		} else if (event.key === "Escape") {
			setOpenProfile(false);
		}
	}

	// return focus to the button when we transitioned from !open -> open
	const prevOpen = React.useRef(openProfile);
	React.useEffect(() => {
		if (prevOpen.current === true && openProfile === false) {
			anchorRef.current.focus();
		}

		prevOpen.current = openProfile;
	}, [openProfile]);

	return (
		<div>
			<IconButton
				ref={anchorRef}
				size="large"
				aria-controls={openProfile ? "composition-menu" : undefined}
				aria-expanded={openProfile ? "true" : undefined}
				aria-haspopup="true"
				color="inherit"
				onClick={handleToggle}
			>
				<AccountCircle />
			</IconButton>

			<Popper
				open={openProfile}
				anchorEl={anchorRef.current}
				role={undefined}
				placement="bottom-start"
				transition
				disablePortal
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin:
								placement === "bottom-start" ? "left top" : "left bottom",
						}}
					>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList
									autoFocusItem={openProfile}
									id="composition-menu"
									aria-labelledby="composition-button"
									onKeyDown={handleListKeyDown}
								>
									<MenuItem onClick={props.logOut}>Logout</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</div>
	);
};

export default MenuPopup;
